var exports = {
  "w": "x9245d464--c443a0--loader",
  "x": "x9245d464--c443a0--skeleton-animation",
};

module.exports = exports;
